import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
} from '@mui/material';
import { AddCircle as AddIcon } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';

import { fetchCourses, createCourse } from 'redux/actions';

const useStyles = makeStyles((theme) => ({
  coursesPaper: {
    padding: theme.spacing(2),
    backgroundColor: '#5b8d8b',
    color: '#fff',
    borderRadius: '8px',
  },
  tableContainer: {
    padding: theme.spacing(0, 2),
    backgroundColor: 'white',
    width: 'unset',
    '& table': {
      width: '100%',
    },
  },
  createButton: {
    marginRight: theme.spacing(1),
    padding: theme.spacing(1, 2),
    backgroundColor: '#2b2f2e',
    marginTop: '20px',
    marginBottom: '10px',
    color: '#fff',
    borderRadius: '32px',
    fontSize: '0.75rem',
    '&:hover': {
      backgroundColor: '#2b2f2e',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
    },
    '& svg': {
      fontSize: '14px',
    },
  },
  organization: {
    backgroundColor: '#5bc0de',
    padding: 5,
    fontSize: 12,
    color: '#fff',
    borderRadius: 3,
    '& span': {
      color: '#000',
      fontWeight: 600,
    },
  },
  newCourseSet: {
    padding: '10px 20px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
  },
  nameInput: {
    width: 300,
    '& label': {
      fontSize: 14,
    },
    '& input': {
      fontSize: 14,
    },
  },
  descriptionInput: {
    marginTop: 15,
    '& label': {
      fontSize: 14,
    },
    '& input': {
      fontSize: 14,
    },
  },
  select: {
    color: '#000',
    marginTop: 15,
    fontSize: 14,
    '& .MuiOutlinedInput-root': {
      fontSize: 14,
      width: '250px',
      height: '35px',
    },
  },
  actionItems: {
    display: 'flex',
    marginTop: 20,
    marginBottom: 15,
    '& button:first-child': {
      borderRadius: 16,
      backgroundColor: '#5b8d8b',
      color: '#fff',
      fontSize: '12px',
      height: '30px',
    },
    '& button:last-child': {
      borderRadius: 16,
      backgroundColor: '#fff',
      color: '#000',
      fontSize: '12px',
      height: '30px',
      border: '1px solid #ccc',
      marginLeft: 10,
    },
  },
}));

const Courses = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const classes = useStyles();
  const user = useSelector((state) => state?.user);
  const courses = useSelector((state) => state?.courses);

  const [showNewCourse, setShowNewCourse] = useState(false);
  const [newCourseName, setNewCourseName] = useState('');
  const [newCourseDescription, setNewCourseDescription] = useState('');
  const [newOrganization, setNewOrganization] = useState(1);

  useEffect(() => {
    dispatch(fetchCourses());
  }, [dispatch]);

  const onSave = () => {
    const payload = {
      school_id: newOrganization,
      name: newCourseName,
      description: newCourseDescription,
      status: 't',
    };

    dispatch(createCourse(payload));

    onCancel();
  };

  const onCancel = () => {
    setShowNewCourse(false);
    setNewCourseName('');
    setNewCourseDescription('');
    setNewOrganization(1);
  };

  return (
    <Paper elevation={0} className={classes.coursesPaper}>
      <Typography sx={{ marginBottom: '16px' }}>Courses</Typography>
      <TableContainer className={classes.tableContainer}>
        <Table
          sx={{ minWidth: 700 }}
          aria-label='cust
        omized table'
        >
          <TableBody>
            {courses &&
              courses.map((row) => (
                <TableRow key={row.id}>
                  <TableCell
                    component='th'
                    scope='row'
                    sx={{
                      width: '50%',
                    }}
                  >
                    <Typography sx={{ fontWeight: '600' }}>
                      {row.name}
                    </Typography>
                    <Typography sx={{ fontWeight: '500', fontSize: 14 }}>
                      {row.description}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <span className={classes.organization}>
                      Org: <span>{row.school_id}</span>
                    </span>
                  </TableCell>
                  <TableCell>
                    <Button>Actions</Button>
                  </TableCell>
                  {/* <TableCell align='center'>
                    <span>{row.group || ''}</span>
                  </TableCell>
                  <TableCell align='center'>
                    <a className={classes.email} href={`mailto:${row.email}`}>
                      {row.email}
                    </a>
                  </TableCell>
                  <TableCell align='center'>
                    <Button
                      className={classes.resendButton}
                      onClick={handleResend}
                    >
                      {STATUS[row.status]}
                    </Button>
                  </TableCell> */}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      {showNewCourse && (
        <div className={classes.newCourseSet}>
          <TextField
            className={classes.nameInput}
            label='Course Name'
            variant='outlined'
            size='small'
            onChange={(e) => setNewCourseName(e.target.value)}
          />
          <TextField
            className={classes.descriptionInput}
            label='Course Description'
            multiline
            rows={5}
            variant='outlined'
            onChange={(e) => setNewCourseDescription(e.target.value)}
          />
          <div className={classes.select}>
            <span>Organization: </span>
            <Select
              defaultValue={1}
              onChange={(e) => setNewOrganization(e.target.value)}
            >
              <MenuItem value={1}>Tucci Learning Solutions</MenuItem>
              <MenuItem value={2}>School Two</MenuItem>
            </Select>
          </div>
          <div className={classes.actionItems}>
            <Button onClick={onSave}>Save</Button>
            <Button onClick={onCancel}>Cancel</Button>
          </div>
        </div>
      )}
      <Button
        className={classes.createButton}
        onClick={() => setShowNewCourse(true)}
      >
        <AddIcon sx={{ marginRight: '8px' }} />
        New Course
      </Button>
    </Paper>
  );
};

export default Courses;
